import { COVERGO_SAAS_DEV, COVERGO_ASIA_PROD, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const axaTh = {
	"axath-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_ASIA_PROD
	},
	"axath-demo-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"axath-test-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_test",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"axath-prod-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_prod",
			appId: "admin_portal"
		},
		envConfig: COVERGO_ASIA_PROD
	},
	"axath-migration-studio.quote.hk": {
		appConfig: {
			tenantId: "axaTh_migration",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"axath-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "axaTh_preprod",
			appId: "admin_portal"
		},
		envConfig: COVERGO_ASIA_PRE_PROD
	}
}
